import { useEffect } from 'react';
import { UnitSystem } from '~/_shared/types/googleMaps/googleMaps.types';
import type { LatLng } from '~/_shared/types/latLng';
import { convertColorToWebGLColor } from '~/_shared/utils/colors/colors.helpers';
import { convertMetersToUnit } from '~/_shared/utils/unitSystem/unitSystem.helpers';
import {
  getSingleZIndex, ZIndexedEntity,
} from '~/map/zIndexes/zIndexRanges';
import { useMapContext } from '../mapContext';

export const PlacesSearchCircleOverlayContainer = ({
  center,
  radius,
  color,
}: {
  center: LatLng;
  radius: number; // in meters
  color: string;
}) => {
  const { webglLayers } = useMapContext();
  const zIndex = getSingleZIndex(ZIndexedEntity.PlacesAreaHighlight);

  useEffect(() => {
    const circleArea = new WebGLOverlay.CircleArea({
      zIndex,
      lat: center.lat,
      lng: center.lng,
      radius: convertMetersToUnit(radius, UnitSystem.metric),
      units: 'metric',
      fillColor: convertColorToWebGLColor(color, 0),
      border: true,
      borderWidth: 3,
      borderColor: convertColorToWebGLColor(color),
    });

    webglLayers.MapObjectCirles.add(circleArea);

    return () => {
      webglLayers.MapObjectCirles.remove(circleArea);
    };
  }, [center.lat, center.lng, color, radius, webglLayers.MapObjectCirles, zIndex]);

  return null;
};
